document.addEventListener('DOMContentLoaded', () => {

    // Restore projectId from localStorage and select the corresponding option
    const savedProjectId = localStorage.getItem('auto_wonder_project_id');
    if (savedProjectId) {
      const projectSelect = document.getElementById('auto_wonder_project_select');
      if (projectSelect instanceof HTMLSelectElement) {
        // Find the option with the saved projectId
        for (let i = 0; i < projectSelect.options.length; i++) {
          const option = projectSelect.options[i];
          if (option && option.value === savedProjectId) {
            projectSelect.selectedIndex = i;

            console.log('Project ID restored from localStorage:', savedProjectId);
            break;
          }
        }
      }
    }
    
    const jwt = localStorage.getItem('app_jwt');
    const dashboard = document.querySelector('.wonders-dashboard');
    if (!dashboard) return;
  
    // Use the wonders balance element by id
    const wondersBalanceEl = document.getElementById('wonders-dashboard__balance');
    if (!wondersBalanceEl) return;
   
    let wondersBalance = parseInt(wondersBalanceEl.getAttribute('data-customer-total-wonders') || '0', 10);
  
    // Track total wonders allocated across all cards
    function getTotalAllocated() {
      if (!dashboard) return 0;
      return Array.from(dashboard.querySelectorAll('.wonders-dashboard__quantity-input'))
        .reduce((sum, input) => {
          if (input instanceof HTMLInputElement) {
            return sum + parseInt(input.value || '0', 10);
          }
          return sum;
        }, 0);
    }
  
    function updateWondersInfo() {
      const used = getTotalAllocated();
      const remaining = Math.max(0, wondersBalance - used);
      if (wondersBalanceEl) wondersBalanceEl.textContent = String(remaining);
    }
  
    function isAutoRedeem() {
      const autoRedeemCheckbox = document.getElementById('auto_redeem');
      return autoRedeemCheckbox instanceof HTMLInputElement ? autoRedeemCheckbox.checked : ((wondersBalanceEl?.getAttribute('data-auto-redeem') || '').trim().toLowerCase() === 'true');
    }
  
    function updateButtonStates() {
      const used = getTotalAllocated();
      if (!dashboard) return;
      dashboard.querySelectorAll('.wonders-dashboard__card').forEach(card => {
        const input = card.querySelector('.wonders-dashboard__quantity-input');
        const btnInc = card.querySelector('.wonders-dashboard__increase');
        const btnDec = card.querySelector('.wonders-dashboard__decrease');
        if (!(input instanceof HTMLInputElement) || !(btnInc instanceof HTMLButtonElement) || !(btnDec instanceof HTMLButtonElement)) return;
        const current = parseInt(input.value || '0', 10);
        // Disable increase, decrease, and input if autoRedeem is true
        btnInc.disabled = isAutoRedeem() || (used >= wondersBalance);
        btnDec.disabled = isAutoRedeem();
        input.disabled = isAutoRedeem();
        // Optionally, prevent input from exceeding wondersBalance
        if (current + (used - current) > wondersBalance) {
          input.value = String(Math.max(0, wondersBalance - (used - current)));
        }
      });
    }

    function updateProgressBar(card) {
      const totalReceivedEl = card.querySelector('.wonders-dashboard__total-received');
      const progressFillEl = card.querySelector('.wonders-dashboard__progress-fill');
      const progressTextEl = card.querySelector('.wonders-dashboard__progress-text');
      const quantityInputEl = card.querySelector('.wonders-dashboard__quantity-input');
      const progressBarEl = card.querySelector('.wonders-dashboard__progress-bar');
      
      if (!totalReceivedEl || !progressFillEl || !progressTextEl || !quantityInputEl || !progressBarEl) return;
      
      // Get current values
      const currentReceived = parseInt(totalReceivedEl.textContent || '0', 10);
      const pendingQuantity = parseInt(quantityInputEl.value || '0', 10);
      const totalReceived = currentReceived + pendingQuantity;
      
      // Get goal from data attribute
      const goal = parseInt(progressBarEl.getAttribute('data-goal') || '100', 10);
      
      // Calculate new percentage
      const percentage = Math.min(100, Math.round((totalReceived * 100) / goal));
      
      // Update progress bar and text
      progressFillEl.style.width = percentage + '%';
      progressTextEl.textContent = percentage + '%';
    }
  
    // Webhook URL (replace with your actual endpoint)
    const METAOBJECT_WEBHOOK_URL = window.webhook_url?.metaobject;

    if (isAutoRedeem()) {
      document.querySelectorAll('.wonders-dashboard__decrease, .wonders-dashboard__increase, .wonders-dashboard__quantity-input, .wonders-dashboard__add-btn').forEach(el => {
        if (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
          el.disabled = true;
        }
      });
    }
  
    if (!dashboard) return;
    dashboard.querySelectorAll('.wonders-dashboard__card').forEach((card, idx) => {
      const input = card.querySelector('.wonders-dashboard__quantity-input');
      const btnInc = card.querySelector('.wonders-dashboard__increase');
      const btnDec = card.querySelector('.wonders-dashboard__decrease');
      const form = card.querySelector('.wonders-dashboard__add-form');
      // Optionally, get a project id from a data attribute or hidden input
      const metaobjectDefinition = card.getAttribute('data-metaobject-definition') || '';
      const metaobjectEntry = card.getAttribute('data-metaobject-entry') || '';
      const metaobjectId = card.getAttribute('data-metaobject-id') || '';
  
      if (!(input instanceof HTMLInputElement) || !(btnInc instanceof HTMLButtonElement) || !(btnDec instanceof HTMLButtonElement) || !(form instanceof HTMLFormElement)) return;
      const inputEl = input;
  
      // Set default value to 0 if empty or invalid
      if (!inputEl.value || isNaN(parseInt(inputEl.value, 10))) {
        inputEl.value = '0';
      }
  
      function handleChange() {
        updateWondersInfo();
        updateButtonStates();
        updateProgressBar(card);
      }
  
      btnInc.addEventListener('click', () => {
        const el = inputEl;
        // Only increase if not exceeding wondersBalance
        const used = getTotalAllocated();
        if (used < wondersBalance) {
          el.value = String(parseInt(el.value, 10) + 1);
          handleChange();
        }
      });
  
      btnDec.addEventListener('click', () => {
        const el = inputEl;
        el.value = String(Math.max(0, parseInt(el.value, 10) - 1));
        handleChange();
      });
  
      inputEl.addEventListener('input', () => {
        // Clamp value between 0 and max allowed
        let val = parseInt(inputEl.value || '0', 10);
        if (isNaN(val) || val < 0) val = 0;
        const usedElsewhere = getTotalAllocated() - val;
        const maxAllowed = Math.max(0, wondersBalance - usedElsewhere);
        if (val > maxAllowed) val = maxAllowed;
        inputEl.value = String(val);
        handleChange();
      });
  
      // Handle form submission to send data to webhook
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const quantity = parseInt(inputEl.value || '0', 10);
        // Get the current total received value from this card
        let totalReceived = '';
        const totalReceivedEl = card.querySelector('.wonders-dashboard__total-received');
        if (totalReceivedEl) {
          totalReceived = totalReceivedEl.textContent || '';
        }

        const totalReceivedUiUpdate = Number(totalReceived) + quantity;
        const totalWonderBalanceUiUpdate = wondersBalance - quantity;

        // Prepare payload
        const payload = {
          customer_wonders: wondersBalance,
          quantity: quantity,
          metaobject_definition: metaobjectDefinition,
          metaobject_entry: metaobjectEntry,
          total_received: totalReceived,
          metaobject_id: metaobjectId
        };
        // Log the payload data
        //console.log('Submitting wonders data:', payload);

                try {
          // Get fresh token for API call
          const token = await window.getAppToken();
          const response = await fetch(METAOBJECT_WEBHOOK_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization':  `Bearer ${token}`
            },
            body: JSON.stringify(payload)
          });
          
          // Optionally handle response
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.json();
          
          if (data.message) {
            alert(data.message);
            return;
          } else {
            // Update only the relevant card's wonders-dashboard__total-received if new total is returned
            const card = document.querySelector('.wonders-dashboard__card[data-metaobject-id="' + metaobjectId + '"]');
            if (card) {
              const totalReceivedEl = card.querySelector('.wonders-dashboard__total-received');
              if (totalReceivedEl) {
                totalReceivedEl.textContent = String(totalReceivedUiUpdate);
              }
              // Reset the quantity input to zero after success
              const quantityInputEl = card.querySelector('.wonders-dashboard__quantity-input');
              if (quantityInputEl && quantityInputEl instanceof HTMLInputElement) {
                quantityInputEl.value = '0';
              }
            }
            wondersBalance -= quantity;
            wondersBalanceEl.setAttribute('data-customer-total-wonders', String(wondersBalance));
            updateWondersInfo();
            updateButtonStates();
            updateProgressBar(card);
          }
        } catch (error) {
          // Optionally handle error
          console.error('Webhook error:', error);
        }
      });
    });
  
    // Initial update
    updateWondersInfo();
    updateButtonStates();

    // Function to update flag based on project name
    function updateFlag(projectName) {
      const flagContainer = document.getElementById('wonders-dashboard__flag');
      if (!flagContainer) return;
      
      // Convert project name to lowercase for case-insensitive matching
      const projectNameLower = projectName.toLowerCase();
      
      // Get all data attributes from the flag container
      const dataAttributes = flagContainer.attributes;
      let flagEmoji = flagContainer.getAttribute('data-india-flag'); // Default to India flag
      
      // Check each data attribute to see if the project name contains the country name
      for (let i = 0; i < dataAttributes.length; i++) {
        const attr = dataAttributes[i];
        if (attr.name.startsWith('data-') && attr.name.endsWith('-flag')) {
          // Extract country name from attribute name (remove 'data-' prefix and '-flag' suffix)
          const countryName = attr.name.replace('data-', '').replace('-flag', '');
          
          // Check if project name contains the country name OR if country name contains project name
          if (projectNameLower.includes(countryName.toLowerCase()) || 
              countryName.toLowerCase().includes(projectNameLower)) {
            flagEmoji = attr.value;
            break; // Use the first match found
          }
        }
      }
      
      // Update the flag emoji
      flagContainer.textContent = flagEmoji;
    }

    // Initialize flag based on currently selected project
    const initialProjectSelect = document.getElementById('auto_wonder_project_select');
    if (initialProjectSelect instanceof HTMLSelectElement && initialProjectSelect.selectedIndex >= 0) {
      const selectedOption = initialProjectSelect.options[initialProjectSelect.selectedIndex];
      const selectedProjectName = selectedOption?.getAttribute('data-project-name') || '';
      updateFlag(selectedProjectName);
    }

    const SET_PROJECT_WEBHOOK_URL = window.webhook_url?.auto_project;
    const projectSelect = document.getElementById('auto_wonder_project_select');
    if (projectSelect instanceof HTMLSelectElement) {
      projectSelect.addEventListener('change', async function() {
        const selectedProjectId = projectSelect.value;
        let selectedProjectTitle = '';
        let selectedProjectName = '';
        if (projectSelect?.options && typeof projectSelect.selectedIndex === 'number' && projectSelect.selectedIndex >= 0 && projectSelect.options.length > projectSelect.selectedIndex) {
          selectedProjectTitle = projectSelect.options[projectSelect.selectedIndex].text;
          selectedProjectName = projectSelect.options[projectSelect.selectedIndex].getAttribute('data-project-name') || '';
        }
        
        // Update flag based on selected project
        updateFlag(selectedProjectName);
        
        const payload = {
          auto_wonder_project_id: selectedProjectId
        };
        try {
          // Get fresh token for API call
          const token = await window.getAppToken();
          const response = await fetch(SET_PROJECT_WEBHOOK_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization':  `Bearer ${token}`
            },
            body: JSON.stringify(payload)
          });
          
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.json();
          const projectId = data[0].auto_wonder_project_id;

          // Save projectId to localStorage
          localStorage.setItem('auto_wonder_project_id', projectId);
          console.log('Project ID saved to localStorage:', projectId);
         

        } catch (error) {
          console.error('Webhook error:', error);
        }
      });
    }

    const SET_REDEEM_WEBHOOK_URL = window.webhook_url?.auto_redeem;
    const autoRedeemCheckbox = document.getElementById('auto_redeem');
    if (autoRedeemCheckbox instanceof HTMLInputElement) {
      autoRedeemCheckbox.addEventListener('change', async function() {
        const payload = {
          auto_redeem: autoRedeemCheckbox.checked
        };

        //console.log(payload)

        try {
          // Get fresh token for API call
          const token = await window.getAppToken();
          const response = await fetch(SET_REDEEM_WEBHOOK_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization':  `Bearer ${token}`
            },
            body: JSON.stringify(payload)
          });
          
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.json();
          
          // Enable or disable wonders controls based on new auto_redeem state
          document.querySelectorAll('.wonders-dashboard__decrease, .wonders-dashboard__increase, .wonders-dashboard__quantity-input, .wonders-dashboard__add-btn').forEach(el => {
            if (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
              el.disabled = autoRedeemCheckbox.checked;
            }
          });
        } catch (error) {
          console.error('Webhook error:', error);
        }
      });
    }
  }); 